export function initSlider() {
  if (typeof Swiper === "undefined") return;

  // Product model slider
  const sliderElements = document.querySelectorAll(".js-slider-product");

  sliderElements.forEach((el) => {
    const parent = el.closest(".p-product-model__slider");
    if (!parent) return;

    const prevButton = parent.querySelector(".js-slider-product-prev");
    const nextButton = parent.querySelector(".js-slider-product-next");

    new Swiper(el, {
      slidesPerView: 1,
      loop: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
    });
  });

  // News slider
  const newsSliders = document.querySelectorAll(".js-slider-news");

  newsSliders.forEach((el) => {
    const parent = el.closest(".p-top-news__slider");
    if (!parent) return;

    const prevButton = parent.querySelector(".js-slider-news-prev");
    const nextButton = parent.querySelector(".js-slider-news-next");

    new Swiper(el, {
      slidesPerView: "auto",
      spaceBetween: 40,
      centeredSlides: true,
      loop: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
    });
  });

  // Product card slider
  const productCardSliders = document.querySelectorAll(".js-slider-product-card");

  productCardSliders.forEach((el) => {
    const parent = el.closest(".p-top-product__slider");
    if (!parent) return;

    const prevButton = parent.querySelector(".js-slider-product-card-prev");
    const nextButton = parent.querySelector(".js-slider-product-card-next");

    new Swiper(el, {
      slidesPerView: "auto",
      spaceBetween: 0,
      loop: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        769: {
          slidesPerView: "auto",
        },
      },
    });
  });

  // Option slider
  const optionSliders = document.querySelectorAll(".js-slider-option");

  optionSliders.forEach((el) => {
    const parent = el.closest(".p-product-option__slider");
    if (!parent) return;

    const prevButton = parent.querySelector(".js-slider-option-prev");
    const nextButton = parent.querySelector(".js-slider-option-next");

    new Swiper(el, {
      slidesPerView: "auto",
      spaceBetween: 10,
      loop: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
    });
  });
}
